import React, { useEffect } from 'react'
import PriceCard from '../../components/PriceCard/PriceCard'
import { FaRegCircle } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import { getAllProduct } from '../../store/features/product/productSlice'
import { useNavigate } from 'react-router-dom'
import { addToCart } from '../../store/features/cart/cartSlice'

const Price = () => {
  document.title = 'MACRUM | Pricing'
  document.querySelector('meta[rel="canonical"]').setAttribute('href', 'https://macrum.in/buy-macrum')
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const {products} = useSelector((store) => store.product)

  useEffect(() => {
    dispatch(getAllProduct())
  },[])

  const handleAddToCart = (product) => {
    dispatch(addToCart(product))
    navigate("/checkout")
  }

  return (
    <div className='px-4 lg:px-16 py-4 pt-28 relative' id='pricing'>
      
      <h2 className='h2 text-white pb-4 text-center w-80 md:w-96 mx-auto relative z-10'>Pricing</h2>

      <div className='w-full col-span-3'>
        <div className='flex flex-wrap justify-center gap-y-8 sm:gap-x-4'>
          <PriceCard
                      title={"Enterprise Edition"}
                      validity={"1 Year"}
                      price={"10000"}
                      taxType={"Inclusive all texes"}
                      numberOfUser={"Multi-user"}
                    />
        </div>
      </div>
    </div>
  )
}

export default Price
